import { styled } from '@stitches/react'

export const WhyWeFeedRawRoot = styled('main', {
  width: '100%',
  position: 'relative'
})